"use client";

import { c as _c } from "react/compiler-runtime";
import { Eye, EyeOff } from "lucide-react";
import { useId, useState } from "react";
import { inputClass, labelClass } from "@/components/form";

/** A password box with a Show/Hide button (44 px touch target). */
export function PasswordField(t0) {
  const $ = _c(33);
  const {
    label,
    value,
    onChange,
    autoComplete: t1,
    hint
  } = t0;
  const autoComplete = t1 === undefined ? "new-password" : t1;
  const [shown, setShown] = useState(false);
  const id = useId();
  const hintId = useId();
  let t2;
  if ($[0] !== id || $[1] !== label) {
    t2 = <label htmlFor={id}>{label}</label>;
    $[0] = id;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = shown ? "text" : "password";
  const t4 = hint ? hintId : undefined;
  let t5;
  if ($[3] !== onChange) {
    t5 = e => onChange(e.target.value.replace(/[\r\n]/g, ""));
    $[3] = onChange;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== autoComplete || $[6] !== id || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== value) {
    t6 = <input id={id} type={t3} className={inputClass} value={value} maxLength={128} autoComplete={autoComplete} spellCheck={false} aria-describedby={t4} onChange={t5} />;
    $[5] = autoComplete;
    $[6] = id;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = value;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== shown) {
    t7 = () => setShown(!shown);
    $[12] = shown;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== label) {
    t8 = label.toLowerCase();
    $[14] = label;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = `Show ${t8}`;
  let t10;
  if ($[16] !== shown) {
    t10 = shown ? <EyeOff className="size-5" aria-hidden="true" /> : <Eye className="size-5" aria-hidden="true" />;
    $[16] = shown;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== shown || $[19] !== t10 || $[20] !== t7 || $[21] !== t9) {
    t11 = <button type="button" onClick={t7} aria-label={t9} aria-pressed={shown} className="flex size-12 shrink-0 items-center justify-center rounded-lg border-[1.5px] border-line-strong text-ink hover:bg-sand">{t10}</button>;
    $[18] = shown;
    $[19] = t10;
    $[20] = t7;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t6) {
    t12 = <span className="flex gap-2">{t6}{t11}</span>;
    $[23] = t11;
    $[24] = t6;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== hint || $[27] !== hintId) {
    t13 = hint && <span id={hintId} className="text-sm font-normal text-muted-foreground">{hint}</span>;
    $[26] = hint;
    $[27] = hintId;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t2) {
    t14 = <div className={labelClass}>{t2}{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t2;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
}